import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "filter mb-8" }
const _hoisted_2 = { class: "filter_top" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "text-gray-800 fs-4 fw-bold mb-3" }, [
  /*#__PURE__*/_createElementVNode("span", null, " Фильтр ")
], -1)
const _hoisted_4 = { class: "form" }
const _hoisted_5 = { class: "form-row form-row-1" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = { class: "mb-2" }
const _hoisted_10 = { class: "form-row form-row-2" }
const _hoisted_11 = { class: "mb-2" }
const _hoisted_12 = { class: "mb-2" }
const _hoisted_13 = { class: "mb-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_15 = { class: "form-row form-row-3" }
const _hoisted_16 = { class: "mb-2" }
const _hoisted_17 = { class: "mb-2" }
const _hoisted_18 = { class: "mb-2" }
const _hoisted_19 = { class: "mb-2" }
const _hoisted_20 = { class: "form-row form-row-0" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Фильтровать ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Сбросить ")
const _hoisted_26 = {
  key: 0,
  class: "px-10 py-4 rounded border text-center mb-4"
}
const _hoisted_27 = {
  key: 1,
  class: "px-10 py-4 rounded border text-center my-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input_text = _resolveComponent("base-input-text")!
  const _component_base_select = _resolveComponent("base-select")!
  const _component_base_single_checkbox = _resolveComponent("base-single-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_base_pre = _resolveComponent("base-pre")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("form", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_base_input_text, {
                placeholder: "Введите ФИО",
                modelValue: _ctx.usersFilterData['filter[name]'],
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.usersFilterData['filter[name]']) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_base_select, {
                class: "w-100",
                placeholder: "Тип пользователя",
                options: [
                {
                  label: 'Покупатель',
                  value: 'buyer',
                },
                {
                  label: 'Продавец',
                  value: 'seller',
                },
              ],
                modelValue: _ctx.usersFilterData['filter[user_type]'],
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.usersFilterData['filter[user_type]']) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_base_input_text, {
                placeholder: "Номер телефона",
                modelValue: _ctx.usersFilterData['filter[phone]'],
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.usersFilterData['filter[phone]']) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_base_input_text, {
                placeholder: "Введите email",
                modelValue: _ctx.usersFilterData['filter[email]'],
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.usersFilterData['filter[email]']) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_base_select, {
                class: "w-100",
                placeholder: "Активность",
                options: [
                {
                  label: 'Активные',
                  value: 'active',
                },
                {
                  label: 'Не активные',
                  value: 'not_active',
                },
              ],
                modelValue: _ctx.usersFilterData['filter[active]'],
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.usersFilterData['filter[active]']) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_base_select, {
                class: "w-100",
                placeholder: "Статус",
                options: [
                {
                  label: 'Все',
                  value: 'all',
                },
                {
                  label: 'Одобренные',
                  value: 'confirmed',
                },
                {
                  label: 'Непроверенные',
                  value: 'not_verified',
                },
                {
                  label: 'Отклонённые',
                  value: 'rejected',
                },
              ],
                modelValue: _ctx.usersFilterData['filter[status]'],
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.usersFilterData['filter[status]']) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_base_input_text, {
                placeholder: "ID юзера",
                modelValue: _ctx.usersFilterData['filter[id]'],
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.usersFilterData['filter[id]']) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _hoisted_14
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_base_single_checkbox, {
                class: "w-100",
                label: "Аккаунт ПРО",
                modelValue: _ctx.usersFilterData['filter[account_pro]'],
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.usersFilterData['filter[account_pro]']) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_base_single_checkbox, {
                class: "w-100",
                label: "Проблемы с email (bounced)",
                modelValue: _ctx.usersFilterData['filter[email_bounced]'],
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.usersFilterData['filter[email_bounced]']) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_base_single_checkbox, {
                class: "w-100",
                label: "Проблемы с email (complained)",
                modelValue: _ctx.usersFilterData['filter[email_complained]'],
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.usersFilterData['filter[email_complained]']) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_base_single_checkbox, {
                class: "w-100",
                label: "Не проверять проблемы с email (bounced или complained)",
                modelValue: _ctx.usersFilterData['filter[email_not_check_bounced]'],
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.usersFilterData['filter[email_not_check_bounced]']) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _hoisted_22,
            _hoisted_23,
            _createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              onClick: _ctx.filterUsersButtonClick
            }, {
              default: _withCtx(() => [
                _hoisted_24
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              size: "small",
              type: "default",
              onClick: _ctx.resetFilterForm
            }, {
              default: _withCtx(() => [
                _hoisted_25
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createVNode(_component_base_pre, {
          hide: "",
          title: "Ads filter data",
          data: _ctx.usersFilterData
        }, null, 8, ["data"])
      ])
    ]),
    (_ctx.showPagination)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createVNode(_component_el_pagination, {
            background: "",
            small: "small",
            "page-size": 10,
            "pager-count": 4,
            total: _ctx.itemsTotal,
            "current-page": _ctx.usersFilterData.page,
            layout: "prev, pager, next",
            onCurrentChange: _ctx.paginationClick
          }, null, 8, ["total", "current-page", "onCurrentChange"])
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default"),
    (_ctx.showPagination)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createVNode(_component_el_pagination, {
            background: "",
            small: "small",
            "page-size": 10,
            "pager-count": 4,
            total: _ctx.itemsTotal,
            "current-page": _ctx.usersFilterData.page,
            layout: "prev, pager, next",
            onCurrentChange: _ctx.paginationClick
          }, null, 8, ["total", "current-page", "onCurrentChange"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}